import { Component, ViewChild, AfterViewInit, OnInit,TemplateRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerApiService } from "app/services/server-api.service";
import { forkJoin } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpClient, HttpEventType, HttpResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';


export type VoucherStatus = 'available' | 'used' | 'expired';

export interface Voucher {
  id: string;
  name: string;           // e.g. "Exam Fee Voucher"
  type: string;           // e.g. "PDF", "QR"
  course: string;         // e.g. "RT Embedded Linux"
  code?: string;          // optional redemption code
  issuedAt: Date;
  expiresAt: Date;
  fileSizeMB: number;
  status: VoucherStatus;
}

type VoucherMeta = {
  id: string;
  name: string;
  issuedAt: Date;
  expiresAt: Date;
  fileSizeMB: number;
};

@Component({
  selector: 'app-vouchers',
  templateUrl: './vouchers.component.html',
  styleUrls: ['./vouchers.component.css']
})
export class VouchersComponent  {
  displayedColumns: string[] = ['select', 'name', 'course', 'issuedAt', 'expiresAt', 'status', 'fileSizeMB', 'actions'];
  dataSource = new MatTableDataSource<Voucher>([]);
  selection = new SelectionModel<Voucher>(true, []);
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('pdfDialog') pdfDialogTpl!: TemplateRef<any>;
  previewSrc: SafeResourceUrl | null = null;


 
  rawUrl = 'http://rt-crm.com:3043/downloads/voucher/';
  pdfUrl: SafeResourceUrl;


  filters = this.fb.group({
    search: [''],
    status: ['all' as 'all' | VoucherStatus],
    course: ['all'],
    issuedFrom: [null],
    issuedTo: [null],
  });

  courses: string[] = [];

  vouchers: VoucherMeta[] = [
    { id: '1', name: 'Vav Voucher', issuedAt: new Date(2025, 5, 1),  expiresAt: new Date(2025, 9, 1),  fileSizeMB: 0.4 },
    { id: '2', name: 'Vav1 Voucher',  issuedAt: new Date(2025, 4, 15), expiresAt: new Date(2025, 8, 15), fileSizeMB: 0.1 },
    { id: '3', name: 'Vav2 Voucher',  issuedAt: new Date(2025, 6, 10), expiresAt: new Date(2025, 10, 10), fileSizeMB: 2.2 },
  ];
    // UX state
  view: 'grid'|'list' = 'grid';
  downloading = new Set<string>();
  progress: Record<string, number> = {};
  activeId: string | null = null; // for the context menu

  constructor(private serverApiService: ServerApiService,private sanitizer: DomSanitizer, private fb: FormBuilder, private snack: MatSnackBar,private http: HttpClient,private dialog: MatDialog,) {
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.rawUrl);
    
  }
// EXACT same idea as your method; now with progress + spinner handling:
  downloadVoucherHttpClient(id: string) {
    const url = this.rawUrl + id;
    this.downloading.add(id);
    this.activeId = id;

    this.http.get(url, {
      responseType: 'blob',
      observe: 'events',
      reportProgress: true,
    }).subscribe({
      next: (event) => {
        if (event.type === HttpEventType.DownloadProgress) {
          if (event.total) {
            this.progress[id] = Math.round(100 * event.loaded / event.total);
          }
        } else if (event.type === HttpEventType.Response) {
          const resp = event as HttpResponse<Blob>;
          const blob = resp.body!;
          const cd = resp.headers.get('content-disposition') || '';
          const m = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(cd);
          const filename = decodeURIComponent(m?.[1] || m?.[2] || `voucher-${id}.pdf`);

          const objectUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = objectUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(objectUrl);

          delete this.progress[id];
          this.downloading.delete(id);
          this.snack.open(`Downloaded ${filename}`, 'OK', { duration: 2000 });
        }
      },
      error: () => {
        this.downloading.delete(id);
        delete this.progress[id];
        this.snack.open('Failed to download voucher.', 'OK', { duration: 2500 });
      }
    });
  }

  // preview(id: string | null) {
  //   if (!id) return;
  //   window.open(this.rawUrl + id, '_blank');
  // }

  preview(id: string) {
  const url = this.rawUrl + id;
  this.http.get(url, { responseType: 'blob' }).subscribe({
    next: (blob) => {
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, '_blank'); // browser PDF viewer
      // cleanup after a while
      setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
    },
    error: () => this.snack.open('Failed to preview voucher.', 'OK', { duration: 2500 })
  });
}


openPreview(id: string) {
  this.activeId = id;
  this.http.get(this.rawUrl + id, { responseType: 'blob' }).subscribe({
    next: (blob) => {
      const blobUrl = URL.createObjectURL(blob);
      this.previewSrc = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
      this.dialog.open(this.pdfDialogTpl, {
        width: '80vw',
        height: '90vh',
        panelClass: 'pdf-dialog'
      }).afterClosed().subscribe(() => {
        this.previewSrc = null;
        URL.revokeObjectURL(blobUrl);
      });
    },
    error: () => this.snack.open('Failed to preview voucher.', 'OK', { duration: 2500 })
  });
}



  copyLink(id: string | null) {
    if (!id) return;
    navigator.clipboard?.writeText(this.rawUrl + id);
    this.snack.open('Direct link copied.', 'OK', { duration: 1500 });
  }

  // For the 3-dot menu to know which card you clicked:
  setActive(id: string) { this.activeId = id; }
  

}
